const basePath = process.env.INTEGRA_DOMAIN;

export function getBreadcrumbLdList({ breadcrubms }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrubms.map((crumb, index) => {
      return {
        '@type': 'ListItem',
        position: index + 1,
        name: crumb.name,
        item: crumb.url && crumb.url.startsWith('http') ? crumb.url : `${basePath}${crumb.url}`,
      };
    }),
  };
}

// const data = {
//   ...otherData,
//   targetLinks: [
//     {id: '1', targetId: 'W', name: 'Woman', url: '/es_ES/mujer/zapatos/m/{sku}'},
//     {id: '2', targetId: 'M', name: 'Men', url: '/es_ES/hombre/zapatos/m/{sku}'}
//   ]
// }
